var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Select from '../select';
import useSelectContext from '../select-context';
import useToggleContext from '~/components/toggle/toggle-context';
import Toggle from '~/components/toggle/toggle';
import ToggleControlBar from '~/components/toggle/toggle-control-bar';
import ArrowToggle from '~/components/toggle/arrow-toggle';
import VerticalList from '~/components/vertical-list/vertical-list';
import './drop-down.scss';
function RenderItem({ item, current, onMouseEnter, onClick }) {
    const { item: selectedItem } = useSelectContext();
    return (React.createElement("div", { role: "option", "aria-selected": item === selectedItem, "aria-current": current, onMouseEnter: onMouseEnter, onClick: onClick }, item.label));
}
function SelectedItem({ placeholder }) {
    const { item } = useSelectContext();
    return (React.createElement("div", { className: "selected-item" }, item ? (item.label) : (React.createElement("span", { className: "placeholder" }, placeholder))));
}
function AutoFocusVerticalList({ options }) {
    const { isOpen, close } = useToggleContext();
    const { select } = useSelectContext();
    const vListRef = React.useRef(null);
    const onSelect = (value) => {
        select(value);
        close();
    };
    React.useEffect(() => {
        var _a;
        if (isOpen) {
            (_a = vListRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isOpen]);
    React.useEffect(() => {
        const initialSelection = options.find((opt) => opt.selected);
        if (initialSelection) {
            select(initialSelection);
        }
    }, [options, select]);
    return (React.createElement("div", { className: "vl-wrapper", hidden: !isOpen, role: "presentation" },
        React.createElement(VerticalList, { items: options, RenderItem: RenderItem, onSelect: onSelect, onCancel: close, vListRef: vListRef })));
}
export default function DropDownSelect(_a) {
    var { options, placeholder = 'Please select' } = _a, passThruProps = __rest(_a, ["options", "placeholder"]);
    return (React.createElement(Select, Object.assign({}, passThruProps),
        React.createElement(Toggle, null,
            React.createElement(ToggleControlBar, { Indicator: ArrowToggle },
                React.createElement(SelectedItem, { placeholder: placeholder })),
            React.createElement(AutoFocusVerticalList, { options: options }))));
}
